import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useCurrentUserQuery } from '@/shared/legacy/hooks/useCurrentUserQuery';
import { QueryKey } from '@/types/query';
import { useGetNylasOauthUrlQuery } from '../../api';

export const useConnectNylasCalendarOpenOAuthPopup = ({ onClosePopup }: { onClosePopup?: () => void }) => {
  const queryClient = useQueryClient();
  const { data: currentUser } = useCurrentUserQuery();
  const { data: oauthUrl } = useGetNylasOauthUrlQuery();

  return useCallback(() => {
    const oauthPopup = window.open(oauthUrl, 'popup', 'popup=true,resizable=1,width=600,height=600');

    const timer = setInterval(async function () {
      if (oauthPopup?.closed) {
        clearInterval(timer);

        await queryClient.resetQueries([QueryKey.useOauthNylasStatusQuery, currentUser?.email]);
        await queryClient.resetQueries([`${currentUser?.email}-oauth-nylas-url`]);

        onClosePopup?.();
      }
    }, 1000);
  }, [oauthUrl]);
};
